/* eslint-disable no-param-reassign */
import { debounce } from 'lodash';
import { PiniaPluginContext } from 'pinia';

const version = 1;

const piniaDebounce = ({ options, store }: PiniaPluginContext) => {
  const debounceOpts = options.debounce;

  if (debounceOpts) {
    // we are overriding the actions with new ones
    return Object.keys(debounceOpts).reduce((debouncedActions, action) => {
      //@ts-ignore
      debouncedActions[action] = debounce(
        store[action],
        //@ts-ignore
        ...debounceOpts[action],
      );
      return debouncedActions;
    }, {});
  }
};

declare module 'pinia' {
  export interface DefineStoreOptionsBase<S, Store> {
    /**
     * Debounce any action by a specified amount of time in ms.
     *
     * @example
     *
     * ```js
     * defineStore('id', {
     *   actions: { someSearch() {}},
     *   debounce: {
     *     // debounce all `someSearch` calls by 300ms
     *     someSearch: 300
     *   }
     * })
     * ```
     */
    debounce?: Partial<
      Record<
        keyof StoreActions<Store>,
        | number
        | (Config extends Record<'Debounce', infer DebounceFn>
          ? _ParamsAfterNumber<DebounceFn>
          : [number, ...any[]])
      >
    >;
  }
}

export type _ParamsAfterNumber<F> = F extends (
  fn: (...args: any[]) => any,
  time: number,
  ...rest: infer Rest
) => any
  ? [number, ...Rest]
  : [number, ...any[]]

export interface Config {
  // Debounce: any
}

export {
  version,
  piniaDebounce,
};
